export default {
    update: "Обновить",
    title: "Обновления",
    columns: {
        name: "Сервис",
        version: "Версия",
        download: "Дата скачивания"
    },
    notification: {
        load_error: "Ошибка загрузки",
        download_ok: "Запрос успешно отправлен",
        download_error: "Ошибка запроса",
    },
}